import { RouteConfig } from 'vue-router'
import { conversationAIRouteNames } from '../constants/location'
import { knowledgeBaseRouteNames } from '../constants/location'
import { requireAuthAndLocation } from '../auth'
import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { agentStudioRouteNames } from '../constants/location/agentStudio'
const AIEmployeePromo = () =>
  import(
    /* webpackChunkName: "ai-employee-promo-location" */ '@/apps/aiEmployeePromo/aiEmployeePromoLocation.vue'
  ).then(m => m.default)

const AIAgentsGettingStarted = () => import('@/apps/aiEmployeePromo/AIAgentsGettingStarted.vue').then(m => m.default)
const ConversationAiSettingsV2 = () => import('@/apps/conversations/settings/aiV2.vue').then(m => m.default)
const KnowledgeBaseSettings = () => import('@/apps/conversations/settings/knowledgeBase.vue').then(m => m.default)
const VoiceAiSettings = () => import('@/apps/voice/settings/ai.vue').then(m => m.default)
const AgentStudio = () => import('@/apps/agentStudio/settings/agentStudio.vue').then(m => m.default)
const contentAIPage = () => import('@/pmd/pages/content_ai/ContentAIPage.vue').then(m => m.default)

export const aiEmployeePromoRoute: RouteConfig[] = [
  {
    path: 'ai-employee-promo',
    name: conversationAIRouteNames.aiEmployeePromoLocation,
    component: AIEmployeePromo,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'ai-agents',
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'getting-started',
        name: conversationAIRouteNames.aiAgentsGettingStarted,
        component: AIAgentsGettingStarted,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'voice-ai',
        name: conversationAIRouteNames.aiAgentsVoiceAi,
        component: VoiceAiSettings,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'conversation-ai',
        name: conversationAIRouteNames.aiAgentsConversationAi,
        component: ConversationAiSettingsV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'agent-studio',
        name: agentStudioRouteNames.aiAgentsAgentStudio,
        component: AgentStudio,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'agent/:agentId',
            name: agentStudioRouteNames.agentStudioAgentVersionManager,
            component: AgentStudio,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'agent/:agentId/versions/:versionId/edit',
            name: agentStudioRouteNames.agentStudioFlowEditor,
            component: AgentStudio,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'content-ai',
        name: conversationAIRouteNames.aiAgentsContentAi,
        component: contentAIPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'knowledge-base',
        name: knowledgeBaseRouteNames.aiAgentsKnowledgeBase,
        component: KnowledgeBaseSettings,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':knowledgeBaseId',
            name: knowledgeBaseRouteNames.editKnowledgeBase,
            component: KnowledgeBaseSettings,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
    ],
  },
]
